import { NavLink, Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import React, { useEffect } from 'react';
// import { reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import logo from '../../static/logo.png';
import { useSelector, useDispatch } from 'react-redux';
import { setFeedbackComp, getCurrentTabData, getJSONTemplates } from '../../store';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ArticleIcon from '@mui/icons-material/Article';
import ListItemIcon from '@mui/material/ListItemIcon';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AdbIcon from '@mui/icons-material/Adb';
const Navbar = () => {
  const [docLink, setDocLink] = React.useState<string>('');
  const dispatch = useDispatch();
  const allTemplates: any[] = useSelector(getJSONTemplates);
  const currentTabData: any = useSelector(getCurrentTabData);

  // For mobile menu open
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const openNav = Boolean(anchorElNav);
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  // End of mobile menu

  // For doc menu
  const [anchorElDoc, setAnchorElDoc] = React.useState<null | HTMLElement>(null);
  const openDoc = Boolean(anchorElDoc);
  const handleDocClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElDoc(event.currentTarget);
  };
  const handleDocClose = () => {
    setAnchorElDoc(null);
  };
  // End of doc menu

  // For tool menu
  const [anchorElTool, setAnchorElTool] = React.useState<null | HTMLElement>(null);
  const openTool = Boolean(anchorElTool);
  const handleToolClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElTool(event.currentTarget);
  };
  const handleToolClose = () => {
    setAnchorElTool(null);
  };
  // End of tool menu

  useEffect(() => {
    if (currentTabData && Object.keys(currentTabData).length > 0 && currentTabData.hasOwnProperty('templateName')) {
      const _selTemplate: any = allTemplates.filter(
        (template: any) => template.fileName === currentTabData['templateName'],
      );
      setDocLink(_selTemplate.length > 0 ? _selTemplate[0]['helpLink'] : '');
    } else {
      setDocLink('');
    }
  }, [currentTabData]);

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            <Typography variant="h6" noWrap component="div" sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}>
              <img src={logo} />
              &nbsp;&nbsp;Grit Software Systems - B2C IEF Editor
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls={openNav ? 'menu-appbar' : undefined}
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                aria-expanded={openNav ? 'true' : undefined}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      left: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
              >
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                    <Link to={'/'} component={RouterLink} underline="none" color="#404040">
                      User Journey Builder
                    </Link>
                  </Typography>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                    <Link to={'/xmlEditor'} underline="none" component={RouterLink} color="#404040">
                      XML Editor
                    </Link>
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    window.open('https://debugdatamsdemostorage.z13.web.core.windows.net/', '_blank');
                  }}
                >
                  <Typography textAlign="center">
                    <Link to="" component={RouterLink} underline="none" color="#404040">
                      Debugger
                    </Link>
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    dispatch(setFeedbackComp(true));
                    handleCloseNavMenu();
                  }}
                >
                  <Typography textAlign="center">
                    <Link to="" component={RouterLink} underline="none" color="#404040">
                      Feedback
                    </Link>
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    window.open(
                      'https://calendly.com/gritiam/demo-of-visual-authentication-journey-builder-clone',
                      '_blank',
                    );
                    handleCloseNavMenu();
                  }}
                >
                  <Typography textAlign="center">
                    <Link to="" component={RouterLink} underline="none" color="#404040">
                      Schedule call for a demo
                    </Link>
                  </Typography>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                    <Link
                      underline="none"
                      color="#404040"
                      to="https://app.archbee.com/public/PREVIEW-ddjwV0RI2eVfcBOylxFGI/PREVIEW-bjH2arQd1Kn4le6z_zH84"
                      target="_blank"
                      component={RouterLink}
                    >
                      Application Documentation
                    </Link>
                  </Typography>
                </MenuItem>

                {docLink != '' && (
                  <MenuItem
                    onClick={() => {
                      window.open(docLink, '_blank');
                      handleDocClose();
                    }}
                  >
                    <Typography textAlign="center">Template Documentation</Typography>
                  </MenuItem>
                )}

                {/* <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                    <NavLink to="https://github.com/Grit-Software-Systems/IEFEditor" target="_blank">
                      <FontAwesomeIcon icon={faGithub as IconProp} />
                    </NavLink>
                  </Typography>
                </MenuItem> */}
              </Menu>
            </Box>
            <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <img src={logo} />
              &nbsp;&nbsp;Grit Software Systems - B2C IEF Editor
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, ml: 'auto' }} justifyContent="flex-end">
              <Link
                color="inherit"
                onClick={handleToolClick}
                sx={{ px: 1, display: 'block', cursor: 'pointer' }}
                underline="none"
                aria-controls={openTool ? 'tool-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openTool ? 'true' : undefined}
              >
                Tools
              </Link>
              <div className="my-auto">|</div>
              <Link
                color="inherit"
                underline="none"
                sx={{ px: 1, display: 'block', cursor: 'pointer' }}
                onClick={() => {
                  dispatch(setFeedbackComp(true));
                }}
              >
                Feedback
              </Link>
              <div className="my-auto">|</div>
              <Link
                color="inherit"
                underline="none"
                sx={{ px: 1, display: 'block', cursor: 'pointer' }}
                onClick={() => {
                  window.open(
                    'https://calendly.com/gritiam/demo-of-visual-authentication-journey-builder-clone',
                    '_blank',
                  );
                }}
              >
                Schedule call for a demo
              </Link>
              <div className="my-auto">|</div>
              <Link
                onClick={handleDocClick}
                color="inherit"
                underline="none"
                sx={{ px: 1, display: 'block', cursor: 'pointer' }}
                aria-controls={openDoc ? 'doc-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openDoc ? 'true' : undefined}
              >
                Documentation
              </Link>
            </Box>
            <Menu
              anchorEl={anchorElTool}
              id="tool-menu"
              open={openTool}
              onClose={handleToolClose}
              onClick={handleToolClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem>
                <Link color="inherit" underline="none" sx={{ px: 1, display: 'block' }} component={RouterLink} to={'/'}>
                  <ListItemIcon>
                    <AccountTreeIcon fontSize="small" />
                  </ListItemIcon>
                  User Journey Builder
                </Link>
              </MenuItem>
              <MenuItem>
                <Link
                  color="inherit"
                  underline="none"
                  sx={{ px: 1, display: 'block' }}
                  component={RouterLink}
                  to={'/xmlEditor'}
                >
                  <ListItemIcon>
                    <BorderColorIcon fontSize="small" />
                  </ListItemIcon>
                  XML Editor
                </Link>
              </MenuItem>
              <MenuItem>
                <Link
                  color="inherit"
                  underline="none"
                  sx={{ px: 1, display: 'block', cursor: 'pointer' }}
                  onClick={() => {
                    window.open('https://debugdatamsdemostorage.z13.web.core.windows.net/', '_blank');
                  }}
                >
                  <ListItemIcon>
                    <AdbIcon fontSize="small" />
                  </ListItemIcon>
                  Debugger
                </Link>
              </MenuItem>
            </Menu>
            <Menu
              anchorEl={anchorElDoc}
              id="doc-menu"
              open={openDoc}
              onClose={handleDocClose}
              onClick={handleDocClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem
                onClick={() => {
                  window.open('https://app.archbee.com/public/PREVIEW-ddjwV0RI2eVfcBOylxFGI/PREVIEW-bjH2arQd1Kn4le6z_zH84', '_blank');
                  handleDocClose();
                }}
              >
                <ListItemIcon>
                  <ArticleIcon fontSize="small" />
                </ListItemIcon>
                Application Documentation
              </MenuItem>
              {docLink != '' && (
                <MenuItem
                  onClick={() => {
                    window.open(docLink, '_blank');
                    handleDocClose();
                  }}
                >
                  <ListItemIcon>
                    <TextSnippetIcon fontSize="small" />
                  </ListItemIcon>
                  Template Documentation
                </MenuItem>
              )}
            </Menu>
            {/* <Box sx={{ flexGrow: 0 }}>
          <Button onClick={props.signOutClickHandler} sx={{ my: 2, color: 'white', display: 'block' }}>Logout</Button>
        </Box> */}
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
    </>
  );
};

// export default withAITracking(reactPlugin, Navbar);
export default Navbar;
